import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductQueryType } from '@models/product.model';
import { ImagePipe } from '@pipes/image.pipe';
import { SLIDE } from '@splidejs/splide';
import { CarouselWrapperComponent } from '../carousel-wrapper/carousel-wrapper.component';

@Component({
  selector: 'market-carousel-nutriday-admin',
  standalone: true,
  imports: [RouterModule, ImagePipe, CarouselWrapperComponent],
  templateUrl: './carousel-nutriday-admin.component.html',
  styleUrl: './carousel-nutriday-admin.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselNutridayAdminComponent implements OnInit {
  readonly PRODUCT_TYPE = ProductQueryType;
  ngOnInit(): void {}

  get options() {
    return {
      type: SLIDE,
      perPage: 3,
      pagination: false,
      arrows: false,
    };
  }
}
